module.exports = __webpack_public_path__ + "static/img/pic.78c1ec0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/pic.png
// module id = o3Ya
// module chunks = 1